import { type CommandSpec } from "./assistant-catalog-types.js";
import { NAV_REGISTRY } from "./assistant-navigation.js";

// Família Navegação (kind `navigate` · safe · auto-executa no cliente). DERIVADA do
// NAV_REGISTRY (fonte única) — assim minRole/args/rota nunca divergem. O modelo só propõe; o cliente
// abre a rota na sessão do próprio usuário (o dado completo vai DB→tela, nunca pelo modelo).
export const NAVIGATE_COMMANDS: readonly CommandSpec[] = Object.entries(NAV_REGISTRY).map(
  ([name, spec]) => ({
    name,
    kind: "navigate" as const,
    riskTier: "safe" as const,
    minRole: spec.minRole,
    argsSchema: spec.argsSchema,
    description: spec.description,
  })
);
